import { Inject, Injectable } from "@angular/core";
import * as signalR from "@microsoft/signalr";
import { HubConnectionState } from "@microsoft/signalr";
import { ApiService } from "./api.service";
import { DeviceHubInfos, LiveNotification, Model_Peripherique, TYPE_LIVE_NOTIFICATION } from "./app.models";
import { AuthService } from "./shared/auth/auth.service";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class SignalRService {
    connection: signalR.HubConnection;
    notificationHub$ = new Subject<LiveNotification>();
    connectedDevices$ = new BehaviorSubject<DeviceHubInfos[]>([]);

    constructor(
      private apiService: ApiService,
      private authService: AuthService,
      private router: Router
    ) {
        this.authService.onUserAuthenticated$
        .subscribe((isAuthenticated: boolean) => {
          if (isAuthenticated) {
            this.doConnectHub();
          } else {
            if (this.connection != null) {
              this.connection.stop();
            }
          }
        });
    }

    doConnectHub() {
        return new Promise<void>((resolve, reject) => {
            const session = this.authService.AuthSession;
            if (!session) {
                reject('Connexion CoreHub impossible: Session invalide.');
            }
            this.connection = new signalR.HubConnectionBuilder()
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Debug)
            .withUrl(this.apiService.apiEndPoint + "/corehub", { accessTokenFactory: () => session.AccessToken })
            .build();

            this._handleEvents();
            this._getStartupInfos().finally(() => resolve());
        });
    }

    private _getStartupInfos() {
      return new Promise<void>((resolve, reject) => {
        this.connection.start().then(() => {
          this.connection.invoke<DeviceHubInfos[]>("GetConnectedDevices").then(_connectedDevices => {
            this.connectedDevices$.next(_connectedDevices);
          });
          resolve()
        }, () => {
          resolve();
        });
      });
    }

    private _handleEvents() {
      this.connection.on('ABWCORE_NOTIFICATION', (notification: LiveNotification) => {
        if (notification.SHOW_NOTIFICATION == true) {
          this.launchWebNotification(notification);
        }
        this.notificationHub$.next(notification);
      });
    }

    private launchWebNotification(liveNotification: LiveNotification) {
      if(! ('Notification' in window) ){
        console.log('Web Notification not supported');
        return;
      }
  
      Notification.requestPermission((permission) => {
        const notification = new Notification("Console Abworkflow",{body:liveNotification.MESSAGE ,icon:'https://abworkflow.com/ui/abw-classic.png', dir:'auto'});
        notification.onclick = () => { 
            switch(liveNotification.TYPE_LIVE_NOTIFICATION) {
                case TYPE_LIVE_NOTIFICATION.PERIPHERIQUE_NEW_REGISTRATION_REQUEST:
                    const peripherique: Model_Peripherique = liveNotification.NOTIFICATION_DATAS;
                    this.router.navigateByUrl(`/views/peripheriques?search=${peripherique.ANDROID_ID}`);
                    break;
            }
        };
      });
    }
}
